export default __webpack_public_path__ + "static/media/icone-escritorio.e2078460.png";